module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QQDDB04KI1GTwAAAC1JREFUOMtj/P//PwMlgImBQkCxAYwMDAz/h7YXWBhC64d4LIxGIwMD49DPTACCsgjrFYpkkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_apa_glp.png
// module id = rNLD
// module chunks = 0